export default {
  esg_dashboard: {
    title: 'แผงหน้าปัด',
  },
  improvement_plans: {
    title: 'แผนการปรับปรุง',
  },
  question_group_section: {
    card_title: 'แบบสำรวจที่ยังไม่มีการตอบ',
    list_header_buyer_company_name: 'บริษัทผู้ซื้อ',
    list_header_question: '@:score_summary_section.list_header_question',
    list_header_deadline: 'กำหนดเส้นตาย',
    list_header_status: 'สถานะ',
    number_of_answered_label: 'จำนวนคำตอบ',
    // number_of_answered_unit: '',
    number_of_answered: 'ความคืบหน้า： {answered}/{total}',
    status_re_answer_request: 'คำขอถอนอยู่ระหว่างดำเนินการ',
    answer: 'คำตอบ',
    withdrawn: 'ถอนแล้ว',
    // no_survey_response_requests_text_1:  '',
    // contact: '',
    // no_survey_response_requests_text_2: '',
  },
  score_summary_section: {
    card_title: '@:common.scorecard.title',
    list_header_buyer_company_name: 'บริษัทผู้ซื้อ',
    list_header_question: 'แบบสอบถาม',
    list_header_create_at: 'วันที่ออก',
    list_header_deadline: 'วันที่มีผลบังคับใช้',
    list_header_status: 'สถานะ',
    limit_one_year: 'หนึ่งปีนับแต่วันที่ออก',
    esg_score: 'คะแนน ESG',
    esg_rating: 'การจัดอันดับ ESG',
    detail: 'รายละเอียด',
  },
  faq_section: {
    card_title: 'คำถามที่พบบ่อย',
    faq_why_request: {
      question:
        'เหตุใดบริษัทของฉันจึงได้รับคำขอให้เข้ารับการประเมิน ASUENE ESG จากพันธมิตรทางธุรกิจของเรา',
      answer:
        'ในช่วงไม่กี่ปีที่ผ่านมา การจัดซื้อจัดจ้างอย่างยั่งยืนเป็นแนวโน้มสำคัญ และบริษัทต่าง ๆ จำเป็นต้องดำเนินธุรกิจโดยคำนึงถึงความจำเป็นทางสังคมที่เกี่ยวข้องกับ ESG ตลอดห่วงโซ่อุปทาน ในความพยายามดังกล่าว องค์กรขนาดใหญ่ไม่เพียงแต่จำเป็นต้องใช้ความคิดริเริ่ม ESG เท่านั้น แต่ยังต้องสนับสนุนให้พันธมิตรทางธุรกิจของตนจัดการกับ ESG อีกด้วย',
    },
    faq_what_benefit: {
      question: 'การประเมิน ASUENE ESG มีประโยชน์อย่างไร',
      answer:
        'การประเมิน ASUENE ESG มีข้อดี 3 ประการ\n1) ทำความเข้าใจจุดแข็งและการปรับปรุงของบริษัทของคุณเกี่ยวกับ ESG\n2) เปรียบเทียบการประเมินของบริษัทของคุณกับบริษัทอื่น ๆ ในอุตสาหกรรมของคุณ\n3) ส่งเสริมความคิดริเริ่ม ESG ของบริษัทของคุณโดยการเปิดเผยผลการประเมิน',
    },
    list: 'ดูรายการ',
  },
  contact_section: {
    card_title: 'ติดต่อเรา',
    description:
      'หากคุณมีคำถามใดๆ เกี่ยวกับแบบสอบถามหรือวิธีการตอบ โปรดติดต่อเราได้ตลอดเวลาหากคุณต้องการรับการสนับสนุนที่เฉพาะเจาะจงมากขึ้นสำหรับการปรับปรุงโครงการริเริ่ม ESG เราสามารถจัดการสนับสนุนอื่น ๆ กับที่ปรึกษาได้',
    inquiry: 'ติดต่อเรา',
  },
}
